import React, { useState, useEffect, useContext } from "react";
import { useFormikContext } from "formik";
import CsplTextBoxField from "../../CsplControls/CsplTextBox/CsplTextBoxField";
import CsplAchField from "../../CsplControls/CsplAch/CsplAchField";
import CsplDateField from "../../CsplControls/CsplDate/CsplDateField";
import CsplRadioButtonField from "../../CsplControls/CsplRadioButton/CsplRadioButtonField";
import OptionalGaurdianNominee from "./OptionalGaurdianNominee";
import CsplNumberField from "../../CsplControls/CsplNumber/CsplNumber";
import { NomineesEnum } from "../../../Enumeration/NomineesEnum";
import { OptionsEnum } from "../../../Enumeration/OptionsEnum";
import KycApplicationContext from "../../../Context/KYCApplicationContext/KYCApplicationContext";
import UseFormikHelper from "../../../Utils/UseFormikHelper";
import styles from "./NominationDetail.module.css";
import { useTranslation } from "react-i18next";
import { TagEnum } from "../../../Enumeration/TagEnum";
import { TagValueEnum } from "../../../Enumeration/TagValueEnum";
import TagValueResource from "../../Resources/CommonResources/TagValueResource";
import CountryResource from "../../Resources/CommonResources/CountryResource";
import {
  VIEW_MODE,
  defaultMobileCountryCode,
} from "../../../Utils/GlobalValues";

//NomineeDetail Component
export default function OptionalNomineeDetail() {
  const { t } = useTranslation("common");
  const applicationContext = useContext(KycApplicationContext);
  let mode = applicationContext.mode;
  const [countryId, setCountryId] = useState();
  const [disable, setDisable] = useState(true);
  const [relationshipId, setRelationshipId] = useState(null);
  const { values, setFieldValue } = useFormikContext();
  const { clearFieldValue } = UseFormikHelper();
  const [getTagValue] = TagValueResource();
  const { getCountryByMobileCountryCode } = CountryResource();
  //Set enable/disable the control
  // disable if it is in view mode
  let isDisabled = applicationContext.disableForm;

  //residential status list
  const residentialStatusList = [
    OptionsEnum.Resident,
    OptionsEnum.Non_Resident_Indian,
    OptionsEnum.OCI_Card_Holder,
    OptionsEnum.Non_Resident_Others,
  ];

  useEffect(() => {
    const currentStatus = values?.nomineeWidgetDTO?.nominee2?.residentialStatus;

    if (currentStatus === OptionsEnum.Non_Resident) {
      values.nomineeWidgetDTO.nominee2.residentialStatus =
        OptionsEnum.Non_Resident_Indian;
    }
  }, [values, setFieldValue]);

  //handling country change
  const handleCountryChange = (value) => {
    setFieldValue("nomineeWidgetDTO.nominee2.state", null);

    if (value && value.mobileCountryCode && value.mobileCountryCode != "") {
      setFieldValue("nomineeWidgetDTO.nominee2.mobileCountry", value);
    } else {
      setFieldValue("nomineeWidgetDTO.nominee2.mobileCountry", null);
    }
  };
  const radioValueList = [OptionsEnum.Yes, OptionsEnum.No];

  const handleRelationship = (newValue) => {
    if (newValue && newValue.name === NomineesEnum.relationship_others) {
      setDisable(false);
      values.nomineeWidgetDTO.nominee2.otherRelationshipRequired = true;
    } else if (newValue && newValue.name !== NomineesEnum.relationship_others) {
      setDisable(true);
      values.nomineeWidgetDTO.nominee2.otherRelationship = "";
      values.nomineeWidgetDTO.nominee2.otherRelationshipRequired = false;
    }
  };

  useEffect(() => {
    if (
      values.nomineeWidgetDTO.nominee2 != null &&
      values.nomineeWidgetDTO.nominee2.relationship != null
    ) {
      handleRelationship(values.nomineeWidgetDTO.nominee2.relationship);
    } else if (
      values.nomineeWidgetDTO.nominee2 != null &&
      values.nomineeWidgetDTO.nominee2.relationship == null
    ) {
      handleRelationship({ name: NomineesEnum.relationship_nan });
    }
  }, [relationshipId, handleRelationship]);

  //Handle Gaurdian Based on Minor
  const handleGaurdianBasedOnMinor = (e) => {
    setFieldValue(e.target.name, e.target.value);
    if (e.target.value === OptionsEnum.Yes) {
      /*  clearingGaurdianDetails(); */
      values.nomineeWidgetDTO.nominee2.guardianDTO.isMinor = OptionsEnum.Yes;
    } else {
      clearFieldValue("nomineeWidgetDTO.nominee2.guardianDTO", {});
      setFieldValue(
        "nomineeWidgetDTO.nominee2.guardianDTO.isMinor",
        OptionsEnum.No,
      );
    }
    clearFieldValue("nomineeWidgetDTO.nominee2.relationship", null);
  };

  //Handle bank account type based on residential status
  const handleBankAccountTypeOnChange = (e) => {
    setFieldValue(e.target.name, e.target.value);

    clearFieldValue("nomineeWidgetDTO.nominee2.country", null);

    clearFieldValue("nomineeWidgetDTO.nominee2.mobileCountry", null);

    clearFieldValue("nomineeWidgetDTO.nominee2.state", null);

    setAccountType(e.target.value);
  };

  function setAccountType(residentialStatus) {
    if (OptionsEnum.Resident === residentialStatus) {
      getTagValue(TagEnum.ACCOUNTTYPE, TagValueEnum.SAVINGS).then(
        (res) => {
          setFieldValue("nomineeWidgetDTO.nominee2.bankAccountType", res);
        },
        (error) => {},
      );
    } else {
      getTagValue(TagEnum.ACCOUNTTYPE, TagValueEnum.NROSAVINGS).then(
        (res) => {
          setFieldValue("nomineeWidgetDTO.nominee2.bankAccountType", res);
        },
        (error) => {},
      );
    }
  }

  /*set Default Values */
  useEffect(() => {
    if (values.nomineeWidgetDTO && values.nomineeWidgetDTO.nominee2) {
      //set default account type
      setdefaultAccountType();

      //set default mobile country
      setdefaultMobileCountry();
    }
  }, []);

  //set default Mobile Country
  function setdefaultMobileCountry() {
    if (
      values.nomineeWidgetDTO.nominee2.mobileCountry == null ||
      values.nomineeWidgetDTO.nominee2.mobileCountry == undefined
    ) {
      getCountryByMobileCountryCode(defaultMobileCountryCode).then(
        (res) => {
          console.log(res);
          setFieldValue("nomineeWidgetDTO.nominee2.mobileCountry", res);
        },
        (error) => {},
      );
    }
  }

  /* Default Value Set */
  function setdefaultAccountType() {
    if (
      values.nomineeWidgetDTO.nominee2.bankAccountType == null &&
      (OptionsEnum.Resident ===
        values.nomineeWidgetDTO.nominee2.residentialStatus ||
        values.nomineeWidgetDTO.nominee2.residentialStatus == undefined)
    ) {
      getTagValue(TagEnum.ACCOUNTTYPE, TagValueEnum.SAVINGS).then(
        (res) => {
          setFieldValue("nomineeWidgetDTO.nominee2.bankAccountType", res);
        },
        (error) => {},
      );
    } else if (
      values.nomineeWidgetDTO.nominee2.bankAccountType == null &&
      OptionsEnum.Non_Resident ===
        values.nomineeWidgetDTO.nominee2.residentialStatus
    ) {
      getTagValue(TagEnum.ACCOUNTTYPE, TagValueEnum.NROSAVINGS).then(
        (res) => {
          setFieldValue("nomineeWidgetDTO.nominee2.bankAccountType", res);
        },
        (error) => {},
      );
    } else {
      //do nothing
    }
  }

  return (
    <>
      {/* get the Another Nominee Details*/}
      <div className="content_body">
        <div className="row ">
          {/* Overall width control */}
          <div className="col-lg-8 col-sm-11 col-12 mx-auto">
            <p>
              <span className={styles.file_instruction}>
                {t("nominee.nomineeHelpText")}
              </span>
            </p>

            {/*Is Yes ,DoB*/}
            <div className="col-sm-11 col-12 me-auto mb-4">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                  <CsplRadioButtonField
                    valuelist={radioValueList}
                    disabled={isDisabled}
                    rowdisplay={true}
                    label={"nominee.nomineeMinor"}
                    name="nomineeWidgetDTO.nominee2.isMinor"
                    defaultValue={OptionsEnum.No}
                    onChange={handleGaurdianBasedOnMinor}
                  ></CsplRadioButtonField>
                </div>

                <div className="w-100 mt-md-2">
                  <div className="w-100  mt-md-1">
                    <CsplDateField
                      name="nomineeWidgetDTO.nominee2.minorDOB"
                      required={true}
                      label={"nominee.dob"}
                      disabled={isDisabled}
                      id="optionalStartDate"
                    ></CsplDateField>
                  </div>
                </div>
              </div>
            </div>

            {/* Prefix & Name */}
            <div className="col-sm-11 col-12 mb-4 me-auto">
              <div className="d-flex justify-content-between">
                <div className="w-50 me-3 ">
                  <CsplAchField
                    lookupName={"salutations"}
                    displayColumn="shortName"
                    idColumn="id"
                    name="nomineeWidgetDTO.nominee2.salutation"
                    required={true}
                    label={"nominee.prefix"}
                    disabled={isDisabled}
                    id="optionalSalutation"
                  ></CsplAchField>
                </div>
                <div className="w-100">
                  <CsplTextBoxField
                    name="nomineeWidgetDTO.nominee2.name"
                    required={true}
                    label={"nominee.name"}
                    disabled={isDisabled}
                    id="optionalName"
                    defaultValue={null}
                  ></CsplTextBoxField>
                </div>
              </div>
            </div>

            {/*Relationship & otherRelationship*/}
            <div className="col-sm-11 col-sm-11 col-12 mb-4 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                  <CsplAchField
                    lookupName={"nomineeRelationship"}
                    displayColumn="name"
                    idColumn="id"
                    name="nomineeWidgetDTO.nominee2.relationship"
                    required={true}
                    label={"nominee.relationshipWithAccountHolder"}
                    disabled={isDisabled}
                    id="optionalRelationship"
                    getIdValue={setRelationshipId}
                    filterValue={values.nomineeWidgetDTO.nominee2.isMinor}
                  ></CsplAchField>
                </div>
                <div className="w-100">
                  <CsplTextBoxField
                    name="nomineeWidgetDTO.nominee2.otherRelationship"
                    required={
                      values.nomineeWidgetDTO.nominee2 != null &&
                      values.nomineeWidgetDTO.nominee2.otherRelationshipRequired
                    }
                    disabled={isDisabled || disable}
                    label={"nominee.otherRelationship"}
                    id="optionalOtherRelationship"
                  ></CsplTextBoxField>
                </div>
              </div>
            </div>

            {/*Residential Status*/}
            <div className="col-sm-11 col-12 mb-0 me-auto">
              <CsplRadioButtonField
                valuelist={residentialStatusList}
                disabled={isDisabled}
                rowdisplay={true}
                label={"nominee.residentialStatus"}
                name="nomineeWidgetDTO.nominee2.residentialStatus"
                defaultValue={OptionsEnum.Resident}
                onChange={handleBankAccountTypeOnChange}
              ></CsplRadioButtonField>
            </div>
            <div className="col-sm-11 col-12 mt-0 mb-4 me-auto">
              {t("nominee.nominee_nro_text")}
            </div>

            {/*AddressLine1*/}

            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                name="nomineeWidgetDTO.nominee2.addressLine1"
                required={false}
                label={"nominee.addressLine1"}
                disabled={isDisabled}
                id="optionalAddressLine1"
              ></CsplTextBoxField>
            </div>

            {/*AddressLine2*/}

            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                name="nomineeWidgetDTO.nominee2.addressLine2"
                required={false}
                label={"nominee.addressLine2"}
                disabled={isDisabled}
                id="optionalAddressLine2"
              ></CsplTextBoxField>
            </div>

            {/*AddressLine3*/}

            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                name="nomineeWidgetDTO.nominee2.addressLine3"
                required={false}
                label={"nominee.addressLine3"}
                disabled={isDisabled}
                id="optionalAddressLine3"
              ></CsplTextBoxField>
            </div>

            {/* City & Country */}

            <div className="col-sm-11 col-sm-11 col-12 mb-4 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                  <CsplTextBoxField
                    name="nomineeWidgetDTO.nominee2.city"
                    required={true}
                    label={"nominee.city"}
                    disabled={isDisabled}
                    id="optionalCity"
                  ></CsplTextBoxField>
                </div>
                <div className="w-100">
                  <CsplAchField
                    lookupName={"countryForNominee"}
                    displayColumn="name"
                    idColumn="id"
                    name="nomineeWidgetDTO.nominee2.country"
                    required={true}
                    label={"nominee.country"}
                    disabled={isDisabled}
                    id="optionalCountry"
                    getIdValue={setCountryId}
                    onValueChange={handleCountryChange}
                    filterValue={
                      values.nomineeWidgetDTO.nominee2.residentialStatus
                    }
                  ></CsplAchField>
                </div>
              </div>
            </div>

            {/* State & Pincode */}

            <div className="col-sm-11 col-sm-11 col-12 mb-4 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                  <CsplAchField
                    lookupName="state"
                    displayColumn="name"
                    idColumn="id"
                    id="optionalState"
                    label="nominee.state"
                    name="nomineeWidgetDTO.nominee2.state"
                    required={true}
                    filterValue={countryId}
                    disabled={isDisabled}
                  />
                </div>
                <div className="w-100">
                  <CsplTextBoxField
                    name="nomineeWidgetDTO.nominee2.pincode"
                    required={true}
                    label={"nominee.pincode"}
                    disabled={isDisabled}
                    id="optionalPincode"
                  ></CsplTextBoxField>
                </div>
              </div>
            </div>

            {/*Mobile Number & email*/}
            <div className="col-sm-11 col-sm-11 col-12 mb-4 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                  <CsplAchField
                    lookupName={"countryCodeForNominee"}
                    displayColumn="mobileCountryCode"
                    secondaryColumn="name"
                    idColumn="id"
                    name="nomineeWidgetDTO.nominee2.mobileCountry"
                    required={
                      values.nomineeWidgetDTO.nominee2.isMinor ===
                      OptionsEnum.No
                    }
                    label={"nominee.mobileCountryCode"}
                    disabled={isDisabled}
                    id="nominee2Mobilecountry"
                    filterValue={
                      values.nomineeWidgetDTO.nominee2.residentialStatus
                    }
                  />
                </div>
                <div className="w-100">
                  <CsplTextBoxField
                    name="nomineeWidgetDTO.nominee2.mobileNo"
                    required={
                      values.nomineeWidgetDTO.nominee2.isMinor ===
                      OptionsEnum.No
                    }
                    label={"nominee.mobileno"}
                    disabled={isDisabled}
                    id="optionalMobileno"
                  ></CsplTextBoxField>
                </div>
              </div>
            </div>

            {/*Email Id*/}

            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                name="nomineeWidgetDTO.nominee2.emailId"
                required={true}
                label={"nominee.email"}
                disabled={isDisabled}
                id="optionalEmail"
              ></CsplTextBoxField>
            </div>

            {/*Bank Name*/}

            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                name="nomineeWidgetDTO.nominee2.bankName"
                required={false}
                label={"nominee.bankName"}
                disabled={isDisabled}
                id="nominee2BankName"
              ></CsplTextBoxField>
            </div>

            {/*IFSC code*/}

            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                name="nomineeWidgetDTO.nominee2.ifscCode"
                required={false}
                label={"nominee.ifscCode"}
                disabled={isDisabled}
                id="nominee2IfscCode"
              ></CsplTextBoxField>
            </div>

            {/*Branch Name*/}

            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                name="nomineeWidgetDTO.nominee2.branchName"
                required={false}
                label={"nominee.branchName"}
                disabled={isDisabled}
                id="nominee2BranchName"
              ></CsplTextBoxField>
            </div>

            {/*Bank Account Number*/}

            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                name="nomineeWidgetDTO.nominee2.bankAccountNumber"
                required={false}
                label={"nominee.bankAccNo"}
                disabled={isDisabled}
                id="nominee2BankAccNo"
              ></CsplTextBoxField>
            </div>

            {/*Bank Account Type accountType*/}

            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplAchField
                lookupName={"accountTypeForResidentialStatus"}
                displayColumn="name"
                idColumn="id"
                name="nomineeWidgetDTO.nominee2.bankAccountType"
                required={false}
                label={"nominee.bankAccType"}
                disabled={isDisabled}
                id="nominee2BankAccType"
                filterValue={values.nomineeWidgetDTO.nominee2.residentialStatus}
              ></CsplAchField>
            </div>

            {/*Is the Nominee Minor*/}
          </div>

          <div div className="col-lg-8 col-sm-11 col-12 mx-auto">
            <div>
              {values !== undefined &&
                values.nomineeWidgetDTO.nominee2 &&
                values.nomineeWidgetDTO.nominee2.isMinor !== OptionsEnum.No && (
                  <div className="">
                    <OptionalGaurdianNominee />
                  </div>
                )}
            </div>

            {/* Nominee 1 & 2 share percentage */}

            <div className="col-sm-11 col-sm-11 col-12 mb-4 me-auto mt-4">
              <div className="d-md-flex justify-content-between">
                {/* Nominee 1 share percentage */}
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                  <CsplNumberField
                    name="nomineeWidgetDTO.nominee1.sharePercentage"
                    required={true}
                    label={"nominee.sharePercentage1"}
                    disabled={isDisabled}
                    id="nominee1SharePercentage"
                    step="1"
                  ></CsplNumberField>
                </div>

                {/* Nominee 2 share percentage */}
                <div className="w-100 ">
                  <CsplNumberField
                    name="nomineeWidgetDTO.nominee2.sharePercentage"
                    required={true}
                    label={"nominee.sharePercentage2"}
                    disabled={isDisabled}
                    id="nominee2SharePercentage"
                  ></CsplNumberField>
                </div>
                {mode && mode !== VIEW_MODE && (
                  <>
                    {" "}
                    <br /> <br /> <br />{" "}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
